export default {
  "brand.cinemaNumber": "劇場数",
  "brand.accountNumber": "アカウント数",
  "brand.code": "ブランドコード（映画ランド用）",
  "brand.operator": "事業者名",
  "brand.basic.brandCode.errmsg": "ブランドコードを入力してください",
  "brand.movi.tkg.code": "興行会社コード",
  "brand.individualInfoObtained": "個人情報個別取得",
  "brand.privacyPolicy": "プライバシーポリシー",
  "brand.recordsBasedOnSpecCommLaw": "特定商取引法に基づく表記",
  "brand.tnc4OnlineBooking": "ネット予約利用規約",
  "brand.tnc4SC": "自動券売機利用規約",
  "brand.copyright": "コピーライト",
  "brand.copyright.placeholder": "例) © Eigaland. Inc. All Rights Reserved.",
  "brand.businessNumber": "課税事業者登録番号",
  "brand.cl.email": "会員システム用メール設定",
};